// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__B0pWQ","mainSection":"styles_mainSection__sSPY9"};